import { render } from "./ActiveToggleSnippet.vue?vue&type=template&id=b90d5004&scoped=true"
import script from "./ActiveToggleSnippet.vue?vue&type=script&lang=js"
export * from "./ActiveToggleSnippet.vue?vue&type=script&lang=js"

import "./ActiveToggleSnippet.vue?vue&type=style&index=0&id=b90d5004&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b90d5004"]])

export default __exports__